import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { useGooglePayConfig } from "../../../../../hooks/modules/PaymentMethodsList/Payments/Adyen/GooglePay/hooks/use-google-pay-config.js";
import useCheckout from "../../../../../../../../../../hooks/adyen/hooks/adyen/useCheckout.js";
import { MobileWalletContainer } from "../../../../../../../../containers/Adyen/MobileWallet/modules/PaymentMethodsList/containers/Adyen/MobileWallet/MobileWalletContainer.js";
import { useAdyen } from "../../../../../../../../../../context/Adyen/context/Adyen/context.js";
import { PaymentInstructionLayout } from "../../../../../../../../component/modules/PaymentMethodsList/component/PaymentInstructionLayout.js";
import { AdyenPaymentType } from "../../../../../../../../../../models/adyen/models/adyen/payment-type.js";
const GooglePay = ({
  cartPrices,
  lineItems,
  setGooglePayToken,
  onClick,
  onAuthorize
}) => {
  const { locale, currency, country } = useIntl();
  const { pspInfo } = useAdyen();
  const checkout = useCheckout();
  const handleOnGpayAuthorized = React.useCallback(
    (paymentData) => {
      onAuthorize?.(paymentData);
      setGooglePayToken(paymentData.paymentMethodData.tokenizationData.token);
    },
    [onAuthorize, setGooglePayToken]
  );
  const { regularGooglePayConfig } = useGooglePayConfig({
    locale,
    cartPrices,
    lineItems,
    currency,
    country,
    onAuthorized: handleOnGpayAuthorized,
    onClick
  });
  const config = regularGooglePayConfig(pspInfo?.merchantId, pspInfo?.gatewayMerchantId);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PaymentInstructionLayout, { info: "checkout.payment.method.googlepay.info" }), /* @__PURE__ */ React.createElement(
    MobileWalletContainer,
    {
      targetId: "googlepay-container",
      checkout,
      paymentType: AdyenPaymentType.GooglePay,
      mobileWalletConfig: config
    }
  ));
};
export {
  GooglePay
};
//# sourceMappingURL=GooglePay.js.map
